$('.textmodule__gallery').slick({
    arrows: false,
    fade: true,
    speed: 800,
    autoplaySpeed: 5000,
    autoplay: true

});
